import type { DirectiveBinding } from 'vue'

import { getConfig } from '@/common/config'
import * as securityHelper from '@/common/securityHelper'

interface PermissionBinding {
  r: string
  o: string
}

const PermissionDirective = {
  mounted(el: HTMLElement, binding: DirectiveBinding<PermissionBinding>) {
    const authMode = getConfig()?.authMode

    // Skip permission check when auth mode is local or none
    if (!authMode || authMode === 'none' || authMode === 'None' || authMode === 'local') {
      return
    }

    const { r: resource, o: operation } = binding.value
    if (!securityHelper.hasPermission(resource, operation)) {
      el.parentElement?.removeChild(el)
    }
  }
}

export default PermissionDirective
